// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _StringUtils {
    constructor() {
        this.THREE_DASHES = '---';
        this.NOT_AVAILABLE = '–';
        this.NOT_AVAILABLE_OLD_CONSTANT = 'N/A'; // Old constant, kept for parsing it from reports
    }
    getAbbreviateText(text) {
        /* #87369 */
        if (!text)
            return '';
        const words = text.split(' ').filter((word) => word.trim()); // foolproof: skip empty and whitespace-only parts
        if (words.length === 1) {
            return words[0].slice(0, 2).toUpperCase();
        }
        if (words.length >= 2) {
            return (words[0][0] + words[1][0]).toUpperCase();
        }
        return '';
    }
}
export const StringUtils = new _StringUtils();
